import KEYCODES from 'common/KeyCodes';

const { ARROW_DOWN, ENTER_KEY, SPACE_KEY } = KEYCODES;

// popper modifier to make popper same width as reference element
const sameWidth = {
  name: 'sameWidth',
  enabled: true,
  phase: 'beforeWrite',
  requires: ['computeStyles'],
  fn: ({ state }) => {
    // eslint-disable-next-line no-param-reassign
    state.styles.popper.width = `${state.rects.reference.width}px`;
  },
  effect: ({ state }) => {
    // eslint-disable-next-line no-param-reassign
    state.elements.popper.style.width = `${
      state.elements.reference.offsetWidth
    }px`;
  }
};

const isToggleMenuKeyPressed = key => key && (key === ENTER_KEY || key === SPACE_KEY || key === ARROW_DOWN);

export {
  sameWidth,
  isToggleMenuKeyPressed,
};
